import React, { useState } from 'react'
import FoodTypeIndicator from '../mini-components/mini-components'
import "./fooditem.css"
import AddItems from '../add-items/AddItems'
import { calculateOriginalPrice } from "../../functions/mini_func.js"
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


const ItemImage = ({ image }) => {
  const [imageLoadError, setImageLoadError] = useState(false);

  const handleImageError = () => {
    setImageLoadError(true);
  };

  return (
    <>
      {imageLoadError ? (
        <div className='item-image-loader'></div>
      ) : (
        <img src={image} style={{
          width: "100%",

        }} onError={handleImageError} alt="" />
      )}
    </>
  );

}


const FoodItem = ({ item, isLast }) => {
  return (
    <>
      <div className='food-item-container' >
        <div className='food-item-info' >
          <FoodTypeIndicator type={item.type} />
          <h3>{item.name}</h3>
          <p>{item.description}</p>
          <h5>{"\u{20B9}"}{calculateOriginalPrice(item.discount, item.price)}
            {
              (item.discount != "" && parseFloat(item.discount) > 0) &&
              <span>{"\u{20B9}"}{item.price} </span>
            }
          </h5>
        </div>
        <div className='food-item-image'>
          <ItemImage image={item.image} />
          <div className='positon-add-items'>
            <AddItems item={item} key={item.dbID} />
          </div>
        </div>
      </div>
      {
        !isLast && <div className='dotted-border' ></div>

      }
    </>
  )
}

export default FoodItem